import name from './name'

const selectSliceData = (state) => state[name]

const selectLearningOverview = (state) =>
  selectSliceData(state).learningOverview

const selectLearningHistory = (state) => selectSliceData(state).learningHistory

const selectInprogressSkillBites = (state) => selectSliceData(state).inprogressSkillBites
const selectCompletedSkillBites = (state) => selectSliceData(state).completedSkillBites

const selectInprogressPlaylists = (state) => selectSliceData(state).inprogressPlaylists
const selectCompletedPlaylists = (state) => selectSliceData(state).completedPlaylists

const selectFilters = state => selectSliceData(state).filters
const selectFromPath = state => selectSliceData(state).fromPath
const selectLearningHistoryFilters = state => selectSliceData(state).learningHistoryFilters

export {
  selectLearningOverview,
  selectLearningHistoryFilters,
  selectInprogressSkillBites,
  selectCompletedSkillBites,
  selectInprogressPlaylists,
  selectCompletedPlaylists,
  selectLearningHistory,
  selectFilters,
  selectFromPath
}
